import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import orderService from './orderService'
import { toast } from 'react-toastify'

const initialState = {
  products: [],
  meistarklases: [],
  coupons: [],
  gramatu_piegade: [],
  order: null,
  orders: null,
  isError: false,
  isSuccess: false,
  isLoading: false,
  message: '',
}

// Get single order
export const getSingleOrder = createAsyncThunk(
  'api/getOrder',
  async (id, thunkAPI) => {
    try {
      const token = thunkAPI.getState().auth.user.token
      return await orderService.getOrder(token, id)
    } catch (error) {
      const message =
        (error.response && error.response.data && error.response.data.message) ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);

// get meistarklases
export const getMeistarklases = createAsyncThunk(
  'api/getMeistarklases',
  async (_, thunkAPI) => {
    try {
      const token = thunkAPI.getState().auth.user.token
      return await orderService.getMeistarklases(token)
    } catch (error) {
      const message =
        (error.response && error.response.data && error.response.data.message) ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);

// export orders
export const exportOrders = createAsyncThunk(
  'api/exportOrders',
  async (data, thunkAPI) => {
    try {
      const token = thunkAPI.getState().auth.user.token
      return await orderService.exportOrders(token, data)
    } catch (error) {
      const message =
        (error.response && error.response.data && error.response.data.message) ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);

// get zurnali gramatas
export const getZurnaliGramatas = createAsyncThunk(
  'api/getZurnaliGramatas',
  async (_, thunkAPI) => {
    try {
      const token = thunkAPI.getState().auth.user.token
      return await orderService.getZurnaliGramatas(token)
    } catch (error) {
      const message =
        (error.response && error.response.data && error.response.data.message) ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);

export const getMeistarklasesApmekletaji = createAsyncThunk(
  'api/getMeistarklasesApmekletaji',
  async (selected_date, thunkAPI) => {
    try {
      const token = thunkAPI.getState().auth.user.token
      return await orderService.getMeistarklaseApmekletaji(token, selected_date)
    } catch (error) {
      const message =
        (error.response && error.response.data && error.response.data.message) ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);

export const sendCoupons = createAsyncThunk(
  'api/sendCoupons',
  async (data, thunkAPI) => {
    try {
      const token = thunkAPI.getState().auth.user.token
      return await orderService.sendCoupons(token, data)
    } catch (error) {
      const message =
        (error.response && error.response.data && error.response.data.message) ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);

export const getAllCashOrders = createAsyncThunk(
  'api/getCashOrders',
  async (page, thunkAPI) => {
    try {
      const token = thunkAPI.getState().auth.user.token
      const orders = await orderService.getCashOrders(token, page)
      return orders.data
    } catch (error) {
      const message =
        (error.response && error.response.data && error.response.data.message) ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);

export const getAllInvoiceOrders = createAsyncThunk(
  'api/getInvoiceOrders',
  async (page, thunkAPI) => {
    try {
      const token = thunkAPI.getState().auth.user.token
      const orders = await orderService.getInvoiceOrders(token, page)
      return orders.data
    } catch (error) {
      const message =
        (error.response && error.response.data && error.response.data.message) ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);

export const getAllOrders = createAsyncThunk(
  'api/getAllOrders',
  async (page, thunkAPI) => {
    try {
      const token = thunkAPI.getState().auth.user.token
      const orders = await orderService.getOrders(token, page);
      return orders
    } catch (error) {
      const message =
        (error.response && error.response.data && error.response.data.message) ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);

export const importMultipleFromNumber = createAsyncThunk(
  'api/import-multiple-number',
  async (data, thunkAPI) => {
    try {
      const token = thunkAPI.getState().auth.user.token
      const orders = await orderService.importMultipleFromNumber(token, data);
      return orders
    } catch (error) {
      const message =
        (error.response && error.response.data && error.response.data.message) ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);

export const getMeistarklaseCoupons = createAsyncThunk(
  'api/meistarklase-coupons',
  async (data, thunkAPI) => {
    try {
      const token = thunkAPI.getState().auth.user.token
      const coupons = await orderService.getMeistarklaseCoupons(token, data);
      return coupons;
    } catch (error) {
      const message =
        (error.response && error.response.data && error.response.data.message) ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);

export const getProducts = createAsyncThunk(
  'api/getProducts',
  async (_, thunkAPI) => {
    try {
      const token = thunkAPI.getState().auth.user.token
      const products = await orderService.getAllProducts(token);
      return products
    } catch (error) {
      const message =
        (error.response && error.response.data && error.response.data.message) ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);

export const getGramatuPiegadeCoupon = createAsyncThunk(
  'api/getGramatuPiegadeCoupon',
  async (_, thunkAPI) => {
    try {
      const token = thunkAPI.getState().auth.user.token
      const coupon = await orderService.getGramatuPiegadeCoupon(token);
      return coupon
    } catch (error) {
      const message =
        (error.response && error.response.data && error.response.data.message) ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);

export const getGramatuPiegadeExpiry = createAsyncThunk(
  'api/getGramatuPiegadeExpiry',
  async (_, thunkAPI) => {
    try {
      const token = thunkAPI.getState().auth.user.token
      const coupon = await orderService.getGramatuPiegadeExpiryDates(token);
      return coupon
    } catch (error) {
      const message =
        (error.response && error.response.data && error.response.data.message) ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);

export const setGramatuPiegadeExpiry = createAsyncThunk(
  'api/setGramatuPiegadeExpiry',
  async (data, thunkAPI) => {
    try {
      const token = thunkAPI.getState().auth.user.token
      const response = await orderService.postGramatuPiegadeExpiryDates(token, data);
      return response
    } catch (error) {
      const message =
        (error.response && error.response.data && error.response.data.message) ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);

// export const getAllErrors = createAsyncThunk(
//   'api/getAllErrors',
//   async (page, thunkAPI) => {
//     try {
//       const token = thunkAPI.getState().auth.user.token
//       const orders = await orderService.getErrors(token, page);
//       return orders
//     } catch (error) {
//       const message =
//         (error.response && error.response.data && error.response.data.message) ||
//         error.message ||
//         error.toString();
//       return thunkAPI.rejectWithValue(message);
//     }
//   }
// );

const downloadExcel = (data, filename) => {
  // Create a Blob from the Excel data (received as a buffer from the backend)
  const blob = new Blob([data], {
      type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  });

  // Create a link element
  const link = document.createElement('a');
  
  // Create a URL for the Blob and set it as the href attribute of the link
  link.href = window.URL.createObjectURL(blob);
  
  // Set the download attribute to the filename you want
  link.download = filename;

  // Append the link to the document body
  document.body.appendChild(link);

  // Programmatically click the link to trigger the download
  link.click();

  // Clean up by removing the link from the DOM
  document.body.removeChild(link);
};

export const orderSlice = createSlice({
  name: 'order',
  initialState,
  reducers: {
    reset: (state) => {
      state.isLoading = false
      state.isSuccess = false
      state.isError = false
      state.message = ''
      state.order = null
      state.orders = null
      state.products = []
      state.meistarklases = []
      state.coupons = []
      state.gramatu_piegade = []

    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getSingleOrder.pending, (state) => {
        state.isLoading = true
      })
      .addCase(getSingleOrder.fulfilled, (state, action) => {
        state.isLoading = false
        state.isSuccess = true
        state.order = action.payload
        state.orders = null
      })
      .addCase(getSingleOrder.rejected, (state, action) => {
        state.isLoading = false
        state.isError = true
        state.message = action.payload
        state.order = null
        state.orders = null
      })
      .addCase(getAllCashOrders.pending, (state) => {
        state.isLoading = true
      })
      .addCase(getAllCashOrders.fulfilled, (state, action) => {
        state.isLoading = false
        state.isSuccess = true
        state.order = null
        state.orders = action.payload
      })
      .addCase(getAllCashOrders.rejected, (state, action) => {
        state.isLoading = false
        state.isError = true
        state.message = action.payload
        state.order = null
        state.orders = null
      })
      .addCase(getAllInvoiceOrders.pending, (state) => {
        state.isLoading = true
      })
      .addCase(getAllInvoiceOrders.fulfilled, (state, action) => {
        state.isLoading = false
        state.isSuccess = true
        state.order = null
        state.orders = action.payload
      })
      .addCase(getAllInvoiceOrders.rejected, (state, action) => {
        state.isLoading = false
        state.isError = true
        state.message = action.payload
        state.order = null
        state.orders = null
      })
      .addCase(getAllOrders.pending, (state) => {
        state.isLoading = true
      })
      .addCase(getAllOrders.fulfilled, (state, action) => {
        state.isLoading = false
        state.isSuccess = true
        state.order = null
        state.orders = action.payload
      })
      .addCase(getAllOrders.rejected, (state, action) => {
        state.isLoading = false
        state.isError = true
        state.message = action.payload
        state.order = null
        state.orders = null
      })
      .addCase(getMeistarklases.pending, (state) => {
        state.isLoading = true
      })
      .addCase(getMeistarklases.fulfilled, (state, action) => {
        state.isLoading = false
        state.isSuccess = true
        state.meistarklases = action.payload
      })
      .addCase(getMeistarklases.rejected, (state, action) => {
        state.isLoading = false
        state.isError = true
        state.message = action.payload
        state.meistarklases = []
      })
      .addCase(getMeistarklasesApmekletaji.pending, (state) => {
        state.isLoading = true
      })
      .addCase(getMeistarklasesApmekletaji.fulfilled, (state, action) => {
        state.isLoading = false
        state.isSuccess = true
        state.orders = action.payload
        console.log(action.payload)
      })
      .addCase(getMeistarklasesApmekletaji.rejected, (state, action) => {
        state.isLoading = false
        state.isError = true
        state.message = action.payload
        state.order = null
        state.orders = null
      })
      .addCase(getZurnaliGramatas.pending, (state) => {
        state.isLoading = true
      })
      .addCase(getZurnaliGramatas.fulfilled, (state, action) => {
        state.isLoading = false
        state.isSuccess = true
        state.products = action.payload
      })
      .addCase(getZurnaliGramatas.rejected, (state, action) => {
        state.isLoading = false
        state.isError = true
        state.message = action.payload
        state.products = []
      })
      .addCase(sendCoupons.pending, (state) => {
        state.isLoading = true
      })
      .addCase(sendCoupons.fulfilled, (state, action) => {
        state.isLoading = false
        state.isSuccess = true
        toast.success("Kuponi ir nosūtīti")
      })
      .addCase(sendCoupons.rejected, (state, action) => {
        state.isLoading = false
        state.isError = true
        state.message = action.payload
      })
      .addCase(exportOrders.pending, (state) => {
        state.isLoading = true
      })
      .addCase(exportOrders.fulfilled, (state, action) => {
        state.isLoading = false
        state.isSuccess = true
        console.log(action.payload)
        downloadExcel(action.payload, 'meistarkalses-apmekletaji.xlsx');
      })
      .addCase(exportOrders.rejected, (state, action) => {
        state.isLoading = false
        state.isError = true
        toast.error(action.payload)
      })
      .addCase(importMultipleFromNumber.pending, (state) => {
        state.isLoading = true
      })
      .addCase(importMultipleFromNumber.fulfilled, (state, action) => {
        state.isLoading = false
        state.isSuccess = true
        toast.success("Pasūtījumi ir importēti")
      })
      .addCase(importMultipleFromNumber.rejected, (state, action) => {
        state.isLoading = false
        state.isError = true
        state.message = action.payload
        toast.error("Kaut kas nogāja greizi")
      })
      .addCase(getMeistarklaseCoupons.pending, (state) => {
        state.isLoading = true
      })
      .addCase(getMeistarklaseCoupons.fulfilled, (state, action) => {
        state.isLoading = false
        state.isSuccess = true
        state.coupons = action.payload
      })
      .addCase(getMeistarklaseCoupons.rejected, (state, action) => {
        state.isLoading = false
        state.isError = true
        state.message = action.payload
        state.coupons = []
      })
      .addCase(getProducts.pending, (state) => {
        state.isLoading = true
      })
      .addCase(getProducts.fulfilled, (state, action) => {
        state.isLoading = false
        state.isSuccess = true
        state.products = action.payload
      })
      .addCase(getProducts.rejected, (state, action) => {
        state.isLoading = false
        state.isError = true
        state.message = action.payload
        state.products = []
      })
      .addCase(getGramatuPiegadeCoupon.pending, (state) => {
        state.isLoading = true
      })
      .addCase(getGramatuPiegadeCoupon.fulfilled, (state, action) => {
        state.isLoading = false
        state.isSuccess = true
        state.coupons = [action.payload]
      })
      .addCase(getGramatuPiegadeCoupon.rejected, (state, action) => {
        state.isLoading = false
        state.isError = true
        state.message = action.payload
        state.coupons = []
      })
      .addCase(getGramatuPiegadeExpiry.pending, (state) => {
        state.isLoading = true
      })
      .addCase(getGramatuPiegadeExpiry.fulfilled, (state, action) => {
        state.isLoading = false
        state.isSuccess = true
        state.gramatu_piegade = action.payload
      })
      .addCase(getGramatuPiegadeExpiry.rejected, (state, action) => {
        state.isLoading = false
        state.isError = true
        state.message = action.payload
        state.gramatu_piegade = []
      })
      .addCase(setGramatuPiegadeExpiry.pending, (state) => {
        state.isLoading = true
      })
      .addCase(setGramatuPiegadeExpiry.fulfilled, (state, action) => {
        state.isLoading = false
        state.isSuccess = true
        state.gramatu_piegade = action.payload
        toast.success("Izmaiņas saglabātas")
      })
      .addCase(setGramatuPiegadeExpiry.rejected, (state, action) => {
        state.isLoading = false
        state.isError = true
        state.message = action.payload
        toast.error("Kaut kas nogāja greizi")
      })
  },
})

export const { reset } = orderSlice.actions
export default orderSlice.reducer